<template>
  <div class="date-compare-container">
    <Checkbox class="date-compare-checkbox" v-model="limit">
      限制后续事件在时间区间内
    </Checkbox>
  </div>
</template>

<script>
export default {
  name: "date-com-end",
  props: {
    limit: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  methods: {},
  watch: {
    limit(limit) {
      this.$emit("on-com-end", limit);
    },
  },
};
</script>

<style scoped>
.date-compare-container {
  position: relative;
}

.date-compare-checkbox {
  float: left;
  padding: 3px 7px 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/my-components/custom-date-picker/base/date-com-end.vue